import { Injectable, inject } from '@angular/core';
import { DirtyCheckPlugin, QueryEntity } from '@datorama/akita';
import { CmgLoanBannerStatusCardState, CmgLoanBannerStatusCardStore } from './loan-banner-status-card.store';

@Injectable({ providedIn: 'root' })
export class CmgLoanBannerStatusCardQuery extends QueryEntity<CmgLoanBannerStatusCardState> {
  protected store: CmgLoanBannerStatusCardStore;

  static instance: CmgLoanBannerStatusCardQuery;
  dirtyChecker = new DirtyCheckPlugin(this);
  constructor() {
    const store = inject(CmgLoanBannerStatusCardStore);

    super(store);
    this.store = store;

    CmgLoanBannerStatusCardQuery.instance = this;
  }
}
